import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import actions from './actions'
import ArrowLeft from '../../assets/svg/Feather/ArrowLeft'
import styles from './Sidebar.module.scss'
import X from '../../assets/svg/Feather/X'

function SidebarDetailHeader(props) {
  const closeSidebar = e => {
    e.preventDefault()
    props.closeSidebar()
  }

  const navigateBack = e => {
    e.preventDefault()
    if (props.hasBackView) {
      props.navigateBack(props.sidebarHistoryStack)
    } else {
      props.collapseSidebar()
    }
  }
  return (
    <>
      <div className={styles.sidebarDetailHeader}>
        <div className={styles.actionButtons}>
          <button className={styles.backButton} onClick={navigateBack}>
            <ArrowLeft size={20} color='#ffffff' />
          </button>
          <div className={styles.mainSection}>
            {props.titleIcon}
            <h1>{props.title}</h1>
          </div>
          <button key={99} className={styles.closeButton} onClick={closeSidebar}>
            <X size={16} color='#fff' />
          </button>
        </div>
      </div>
      <div className={styles.sidebarDetailSubheader}>{props.titlePhoto}</div>
      <div>{props.descriptionText ? <p className={styles.descriptionText}>{props.descriptionText}</p> : null}</div>
    </>
  )
}

SidebarDetailHeader.propTypes = {
  backButtonOnClick: PropTypes.func,
  descriptionText: PropTypes.string,
  hasBackView: PropTypes.bool,
  sidebarHistoryStack: PropTypes.array,
  style: PropTypes.object,
  title: PropTypes.string,
  titleIcon: PropTypes.object,
  titlePhoto: PropTypes.object,
  // actions
  closeSidebar: PropTypes.func,
  collapseSidebar: PropTypes.func,
  navigateBack: PropTypes.func
}

export default connect(model => {
  const { sidebarHistoryStack } = model.app
  const hasBackView = sidebarHistoryStack.length > 0
  return {
    hasBackView,
    sidebarHistoryStack
  }
}, actions)(SidebarDetailHeader)
